import get from 'lodash.get';
import {
    reducer as sharedReducer,
    selectors as sharedSelectors,
} from '../shared/enrollmentReducer';
import { FETCH_ENROLLMENT_INFO } from '../../actionTypes/shared/apiActionTypes';
import { LICENSE } from '../../../constants/reading/CommonConstants';
import processEnrollmentData from './enrollmentReducerParsers';
import KeycloakClient from '../../clients/shared/KeycloakClient';

const { HIDE_ACADIENCE_READING } = LICENSE;

export const initialState = {
    data: {},
    isDataFetched: false,
    error: null,
};

export const reducer = (state = initialState, action = {}) => {
    if (action.type === FETCH_ENROLLMENT_INFO.SUCCESS) {
        return {
            ...state,
            isDataFetched: true,
            data: processEnrollmentData({
                ...action.additionalResponseParams,
                data: action.response,
            }),
        };
    }

    return sharedReducer(state, action);
};

const isAcadienceReadingHidden = state =>
    sharedSelectors.getLicensingInfo(state).includes(HIDE_ACADIENCE_READING) ||
    !KeycloakClient.isMasUser();

const getBurstGroupId = state => get(state.data, 'burstGroupUid');

const getIsDTC = state => get(state.staffConfig, 'isDistrictTestingCoordinator', false);

export const selectors = {
    ...sharedSelectors,
    getBurstGroupId,
    isAcadienceReadingHidden,
    getIsDTC,
};
